import { useMemo } from 'react';
import queryString from 'query-string';

let inIframe: boolean;
try {
    inIframe = window.self !== window.top;
} catch (e) {
    inIframe = true;
}

// default to standalone=true
const useIsStandalone = () => {
    return useMemo(() => {
        if (inIframe) {
            return false;
        }

        const parsed = queryString.parse(location.search) ?? {};

        if (parsed?.standalone === 'false') {
            localStorage.setItem('standalone', 'false');
        } else if (parsed?.standalone === 'true') {
            // ensures that we reset to default
            localStorage.removeItem('standalone');
        }
        return JSON.parse(localStorage.getItem('standalone')) ?? true;
    }, [location.search]);
};

export default useIsStandalone;
